import styled, { css } from 'styled-components';
import {
  getSpace,
  mq,
  gridContainer,
  setGridColumns,
  getColor,
  getGridColumns
} from '../../../stylesheets/tools';
import { colorThemes } from '../../../stylesheets/themes';

const StyledEventTeaserList = styled.section`
  padding: ${getSpace('xl')} 0;

  ${mq('l')} {
    padding: 100px 0;
  }

  .teaser-list {
    display: flex;
    flex-direction: column;
    gap: 20px 60px;

    ${mq('m')} {
      ${gridContainer()}
      ${setGridColumns('1fr', 2)}
    }
    ${mq('xl')} {
      ${setGridColumns('1fr', 3)}
    }

    .teaser-list__headline {
      ${getGridColumns([1, 2], { xl: [1, 3] })}
      margin-bottom: ${getSpace('xxs')};
    }

    .teaser-list__more {
      text-align: center;
      order: 4;
      align-content: end;
      
      ${mq('m')} {
        margin-bottom: ${getSpace('xs')};
        order: unset;
        text-align: right;
      }

    }
    .teaser-list__more-cta {
      display: block;
      padding: 15px;
      ${props =>
        (props.colorScheme === 'useGlobal' || !props.colorScheme) &&
        css`
          color: ${props.accessibilityDefaultTheme
            ? props.theme.globalTheme.contrastCta
            : props.theme.globalTheme.contrastCta};
        `}
      ${props =>
        props.colorScheme &&
        props.colorScheme !== 'useGlobal' &&
        css`
          color: ${props.accessibilityDefaultTheme
            ? props.theme.globalTheme.contrastCta
            : colorThemes[props.colorScheme].contrastCta};
        `}
      ${mq('m')} {
        padding: 0;
      }
    }
    .teaser-list__preview {
      display: none;

      .teaser-list__preview-sticky-image {
        position: sticky;
        top: 20px;
      }

      .teaser-list__preview-image {
        aspect-ratio: 3/4;
        object-fit: cover;
      }
      ${mq('xl')} {
        display: block;
      }
    }
    .teaser-list__no-events {
      p {
        margin-bottom: ${getSpace('xxxs')};
      }
      .teaser-list__more-cta {
        padding: 0;
      }
    }
    .teaser-list__grid {
      border-top: 2px solid ${getColor('gray')};
      padding-top: ${getSpace('s')};
      ${getGridColumns([1, 3], { xl: [2, 4] })}

      ${mq('l')} {
        .teaser-list__grid-container {
          margin: 0 -1.25rem;
        }
      }
    }
  }
`;

export default StyledEventTeaserList;
